module.exports = __webpack_public_path__ + "img/fc6fb344ea237131fcdf95bf033dc20f.png";